import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useFolderBookmarks } from '../services/dataHooks';
import { useFolderBySlug } from '../hooks/useFolderBySlug';

export const Route = createFileRoute('/_app/folder/$slug/read/$id')({
  component: FolderReadPage,
});

function FolderReadPage() {
  const { slug } = Route.useParams();
  const { preferences } = useUserPreferences();
  const currentFolder = useFolderBySlug(slug);
  const { bookmarks, isLoading: isBookmarkCollectionLoading } = useFolderBookmarks(
    currentFolder?.id || '',
    1,
  );

  return (
    <BookmarkListPage
      mode="folder"
      bookmarks={bookmarks}
      currentFolderId={currentFolder?.id}
      currentFolder={currentFolder}
      folderTitle={currentFolder?.displayTitle}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
    />
  );
}
